module.exports = __webpack_public_path__ + "static/bump-f18a6d9a674e4f5f85e089c9b9a11795.png";